export const iconFontAwesomeSportsFitnessBasketball = (
	<i className="fa-solid fa-basketball"></i>
);
